<template>
  <div class="org-container">
    <el-button type="success" @click="syncChinaRegion">同步全国省市区</el-button>
   
  </div>
</template>

<script>

export default {
  name: '',
 
  data() {
    return {
     
    }
  },
  methods: {
    syncChinaRegion(){
		this.API.post(this.API.admin.postSyncChina).then(res=>{
			console.log('res',res.data)
		})
	},
    },
}
</script>

<style scoped>
.org-container {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  height: 100%;
  box-sizing: border-box;
}
.menu-tabs {
  margin-bottom: 20px;
}
.menu-tabs .el-button {
  margin-right: 10px;
}
</style>